<template>
    <div style="position: relative; width:100%; height: 100%;">
        <canvas ref="myChart" style="width:100%; height: 100%;" @click.stop=""></canvas>
    </div>
</template>

<script>
    import Chart from 'chart.js';
    import DoughnutPlugin from '../helpers/DoughnutPlugin';

    export default {
        name: "chart",

        props: ['chartData', 'chartOptions', 'type', 'controlClick'],

        data() {
            return {
                chartObj: null
            }
        },

        watch:{
            chartData() {
                let vm = this;
    console.info('this.chartOptions', this.chartOptions);
                let opt = vm.chartOptions;
    
                if(this.controlClick){
                    opt = Object.assign(vm.chartOptions, {
                        onClick: event => {
                            if(vm.chartObj.getElementAtEvent(event)[0]) {
                                const datasetIndex = vm.chartObj.getElementAtEvent(event)[0]._datasetIndex;
                                const dataIndex = vm.chartObj.getElementsAtEvent(event)[datasetIndex]._index;
                                vm.$emit('onBarClick', [datasetIndex, dataIndex, event.clientX, event.clientY]);
                            }else{
                                vm.$emit('onBarClick', null);
                            }
                        },
                        onHover: event => {
                            let point = vm.chartObj.getElementAtEvent(event);
                            if (point.length)
                                event.target.style.cursor = 'pointer';
                            else
                                event.target.style.cursor = 'default';
                        }
                    })
                }
    console.info('opt', opt);
                this.chartObj.options = opt;
    console.info('this.chartObj.options', this.chartObj.options);
                this.chartObj.data = this.chartData;

                this.chartObj.update();/* */
            }
        },

        methods: {
            update(opts){
                this.chartObj.options.tooltips.enabled = opts.tooltips.enabled;
                this.chartObj.update();
            }
        },

        mounted() {
            let vm = this;

            let ctx = vm.$refs['myChart'];

            let opt = vm.chartOptions;
            this.chartObj = new Chart(ctx, {
                type: vm.type || 'bar',
                data: vm.chartData,
                options: opt
            });
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/Chart.vue